/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type FreezeTransactionRecipientWalletQueryVariables = {
    mobile: string;
};
export type FreezeTransactionRecipientWalletQueryResponse = {
    readonly wallet: {
        readonly balance: string;
    } | null;
};
export type FreezeTransactionRecipientWalletQuery = {
    readonly response: FreezeTransactionRecipientWalletQueryResponse;
    readonly variables: FreezeTransactionRecipientWalletQueryVariables;
};



/*
query FreezeTransactionRecipientWalletQuery(
  $mobile: String!
) {
  wallet(mobile: $mobile) {
    balance
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mobile"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "mobile",
    "variableName": "mobile"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FreezeTransactionRecipientWalletQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FreezeTransactionRecipientWalletQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "92c3c9d7081a0b68f7691a3354c8d687",
    "id": null,
    "metadata": {},
    "name": "FreezeTransactionRecipientWalletQuery",
    "operationKind": "query",
    "text": "query FreezeTransactionRecipientWalletQuery(\n  $mobile: String!\n) {\n  wallet(mobile: $mobile) {\n    balance\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '8bb87bc59eeef2b0b96b2eda880e639b';
export default node;
